export const GENERIC_ERROR =
  "Sorry something went wrong. Please try again later";
export const DYNAMIC_FORMS = "DYNAMIC_FORMS";
export const DEMO_IMS_CLIENT_ID = "dynamic-forms-demo";

export const IMS_LIB_JS_STAGE =
  "https://auth-stg1.services.adobe.com/imslib/imslib.min.js";
export const IMS_LIB_JS_PROD =
  "https://auth.services.adobe.com/imslib/imslib.min.js";
export const ENABLE_LOGS = "logsEnabled";
export const ADOBE_CLEAN_CSS = "https://use.typekit.net/shu5jul.css";
